<template>
  <v-flex>
    <v-container>
      <v-card class="mx-auto pl-4" min-width="100%">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline font-weight-bold">
              Account Profile
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="loading">
          <v-card-text>
            Now loading...
            <v-progress-linear
              indeterminate
              color="primary"
              class="mb-10"
            ></v-progress-linear>
          </v-card-text>
        </template>
        <template v-else>
          <v-list-item>
            <v-list-item-content>
              <!-- AccountID section start-->
              <v-form @submit.prevent>
                <v-row>
                  <v-col md="3">
                    Account ID
                  </v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="profile.AccountId"
                      filled
                      single-line
                      dense
                      disabled
                      name="account_id"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3"></v-col>
                </v-row>
              </v-form>
              <!-- Full name section start-->
              <v-form ref="form" v-model="name.updatable" @submit.prevent>
                <v-row v-if="name.editable">
                  <v-col md="3">Full name</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="name.value"
                      outlined
                      dense
                      :rules="name.rules"
                      name="full_name"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <template v-if="name.updatable && name.value">
                      <v-btn
                        icon
                        color="success"
                        class="mr-2 ml-3"
                        @click="
                          updateAttribute('UserName', name.value)
                          name.editable = false
                        "
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn icon class="mr-2 ml-3" disabled>
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <v-btn
                      text
                      color="warning"
                      @click="
                        name.value = profile.UserName || ''
                        name.editable = false
                      "
                    >
                      cancel
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col md="3">Full name</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="name.value"
                      filled
                      single-line
                      dense
                      readonly
                      name="full_name"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <v-btn text color="success" @click="name.editable = true">
                      edit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <!-- Email section start-->
              <v-form @submit.prevent>
                <v-row>
                  <v-col md="3">Email</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="email.value"
                      filled
                      single-line
                      dense
                      disabled
                      name="email"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3"></v-col>
                </v-row>
              </v-form>
              <!-- Institution/Company section start-->
              <v-form
                ref="form"
                v-model="institution.updatable"
                @submit.prevent
              >
                <v-row v-if="institution.editable">
                  <v-col md="3">
                    Institution/Company
                    <p style="font-size: 0.8em; color: gray">
                      Hint: University, instituion or company name
                    </p>
                  </v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="institution.value"
                      outlined
                      dense
                      :rules="institution.rules"
                      name="institution"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <template v-if="institution.updatable && institution.value">
                      <v-btn
                        icon
                        color="success"
                        class="mr-2 ml-3"
                        @click="
                          updateAttribute('Affiliation', institution.value)
                          institution.editable = false
                        "
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn icon class="mr-2 ml-3" disabled>
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <v-btn
                      text
                      color="warning"
                      @click="
                        institution.value = profile.Affiliation || ''
                        institution.editable = false
                      "
                    >
                      cancel
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col md="3">
                    Institution/Company
                    <p style="font-size: 0.8em; color: gray">
                      Hint: University, instituion or company name
                    </p>
                  </v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="institution.value"
                      filled
                      single-line
                      dense
                      readonly
                      name="institution"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <v-btn
                      text
                      color="success"
                      @click="institution.editable = true"
                    >
                      edit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <!-- Country section start-->
              <v-form @submit.prevent>
                <v-row v-if="country.editable">
                  <v-col md="3">Country</v-col>
                  <v-col md="5">
                    <v-select
                      v-model="country.value"
                      :items="country.options"
                      label="Select"
                      dense
                      outlined
                      name="country"
                    ></v-select>
                  </v-col>
                  <v-col md="3">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="
                        updateAttribute('Country', country.value)
                        country.editable = false
                      "
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                      text
                      color="warning"
                      @click="
                        country.value = profile.Country || ''
                        country.editable = false
                      "
                    >
                      cancel
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col md="3">Country</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="country.value"
                      filled
                      single-line
                      dense
                      readonly
                      name="country"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <v-btn
                      text
                      color="success"
                      @click="country.editable = true"
                    >
                      edit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <!-- Web site section start-->
              <v-form ref="form" v-model="website.updatable" @submit.prevent>
                <v-row v-if="website.editable">
                  <v-col md="3">Web site</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="website.value"
                      outlined
                      dense
                      :rules="website.rules"
                      name="web_site"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <template v-if="website.updatable">
                      <v-btn
                        icon
                        color="success"
                        class="mr-2 ml-3"
                        @click="
                          updateAttribute('Website', website.value)
                          website.editable = false
                        "
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn icon class="mr-2 ml-3" disabled>
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <v-btn
                      text
                      color="warning"
                      @click="
                        website.value = profile.Website || ''
                        website.editable = false
                      "
                    >
                      cancel
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col md="3">Web site</v-col>
                  <v-col md="5">
                    <v-text-field
                      v-model="website.value"
                      filled
                      single-line
                      dense
                      readonly
                      name="web_site"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <v-btn
                      text
                      color="success"
                      @click="website.editable = true"
                    >
                      edit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-row class="mt-5">
                <!-- Change password start-->
                <v-col cols="8" class="mb-8">
                  <v-btn
                    text
                    absolute
                    class="text-none"
                    color="primary"
                    @click="setChangePasswordDialog(true)"
                    style="padding: 0px;"
                  >
                    Change password
                  </v-btn>
                </v-col>
                <!-- Delete account start-->
                <v-col v-if="loading" cols="3" class="mb-10">
                  <v-progress-circular
                    class="ml-3"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-col>
                <v-col
                  v-else-if="currentPlan !== 'Free'"
                  cols="3"
                  class="mb-10"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <v-btn
                        text
                        absolute
                        class="text-none"
                        color="grey"
                        v-on="on"
                      >
                        Delete acount
                      </v-btn>
                    </template>
                    <span>
                      To delete account, your subscription plan must be changed
                      to Free
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col v-else cols="3" class="mb-10">
                  <v-btn
                    text
                    absolute
                    class="text-none"
                    color="error"
                    @click="setDeleteUserDialog(true)"
                  >
                    Delete acount
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </template>
        <change-password-dialog
          :changePasswordDialog="changePasswordDialog"
          @setChangePasswordDialog="setChangePasswordDialog"
        ></change-password-dialog>
        <delete-user-dialog
          :deleteUserDialog="deleteUserDialog"
          @setDeleteUserDialog="setDeleteUserDialog"
        ></delete-user-dialog>
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

import {Auth} from 'aws-amplify'
import ChangePasswordDialog from '@/components/account/ChangePasswordDialog.vue'
import DeleteUserDialog from '@/components/account/DeleteUserDialog.vue'
import Countries from '@/utils/Countries.js'

export default {
  name: 'Profile',
  title: 'profile',
  components: {
    ChangePasswordDialog,
    DeleteUserDialog,
  },
  data: () => ({
    changePasswordDialog: false,
    deleteUserDialog: false,
    currentPlan: null,
    profile: {
      AccountId: '',
      UserName: '',
      Affiliation: '',
      Country: '',
      Website: '',
    }, // keeping value
    email: {
      value: '',
    },
    name: {
      value: '',
      editable: false,
      updatable: false,
      rules: [
        (v) =>
          !v ||
          /^[A-Za-z' ']*$/i.test(v) ||
          'Only alphabets and spaces can be used.',
        (v) => !v || v.length <= 200 || 'Please enter within 200 characters.',
      ],
    },
    institution: {
      value: '',
      editable: false,
      updatable: false,
      rules: [
        (v) =>
          !v ||
          /^[A-Za-z' ']*$/i.test(v) ||
          'Only alphabets and spaces can be used.',
        (v) => !v || v.length <= 200 || 'Please enter within 200 characters.',
      ],
    },
    website: {
      value: '',
      editable: false,
      updatable: false,
      rules: [
        (v) => !v || v.length <= 200 || 'Please enter within 200 characters.',
      ],
    },
    country: {
      value: '',
      editable: false,
      options: Countries,
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    ...mapMutations({
      setUser: 'auth/setUser',
      setUserProfile: 'auth/setUserProfile',
    }),
    setChangePasswordDialog(show) {
      this.changePasswordDialog = show
    },
    setDeleteUserDialog(show) {
      this.deleteUserDialog = show
    },
    updateAttribute: async function(attributeName, attributeValue) {
      if (this.profile[attributeName] === attributeValue) return
      this.loading = true
      await this.editMyAccount({
        [attributeName]: attributeValue,
      })
      await this.initProfile()
      this.loading = false
    },
    refreshUser: async function() {
      const user = await Auth.currentAuthenticatedUser({
        // If set to true, this call will send a request to Cognito to get the latest user data
        bypassCache: true,
      })
      this.setUser(user)
      const myPlan = await this.getMyPlan()
      this.currentPlan = this.ucfirst(myPlan.data.CurrentPlan)
    },
    initProfile: async function() {
      this.profile = await this.getMyAccount()
      this.email.value = this.user.attributes.email
      this.name.value = this.profile.UserName
      this.institution.value = this.profile.Affiliation
      this.country.value = this.profile.Country
      this.website.value = this.profile.Website
      this.setUserProfile(this.profile)
    },
  },
  mounted: async function() {
    this.loading = true
    await this.refreshUser()
    await this.initProfile()
    this.loading = false
  },
}
</script>
